import React,{Suspense} from 'react'
import ContentLoader from 'react-content-loader'

import "./contentLoader.scss"

const ThreeDots = props => (
  <ContentLoader
    viewBox="0 0 400 160"
    height={160}
    width={400}
    backgroundColor="transparent"
    {...props}
  >
    <circle cx="150" cy="86" r="8" />
    <circle cx="194" cy="86" r="8" />
    <circle cx="238" cy="86" r="8" />
  </ContentLoader>
)

const FallbackComponent=({isLoginPage})=>{
  return (
        <div style={{width:"100vw",height:"100vh",display:"flex",justifyContent:"center",alignItems:"center",}} className={`${isLoginPage ? 'login-loading-page-wrapper':''}`}>
                      {/* {isLoginPage ? <ThreeDots foregroundColor="#404040"/> : <ThreeDots /> } */}
                      <span className='content-loader'></span>
        </div >
  )
}


const WithThreeDotsContentLoader=({children,isLoginPage})=>{
    return (
        <Suspense fallback={
            <FallbackComponent isLoginPage={isLoginPage}/>}>
              <div style={{height:"100vh"}}>{children}</div>
          </Suspense>)
    
}

export default WithThreeDotsContentLoader